import { render, staticRenderFns } from "./FileDocumentOutlineIcon.vue?vue&type=template&id=61d5e02e"
import script from "./FileDocumentOutlineIcon.vue?vue&type=script&lang=js"
export * from "./FileDocumentOutlineIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports